import React, { useEffect } from "react";

import { collection, orderBy, query, doc, where } from "firebase/firestore";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import { useRound } from "context/roundContext";
import { useLeague } from "context/leagueContext";
import { useUser } from "reactfire";

function useRoundData(roundId) {
  const { dispatch: roundDispatch } = useRound();
  const {
    state: { leagueInfo },
  } = useLeague();
  const { status, data: user } = useUser();
  const firestore = useFirestore();

  const roundEventsCollection = collection(
    firestore,
    "leagues/" +
      leagueInfo?.leagueRef +
      "/seasons/" +
      leagueInfo?.seasonRef +
      "/rounds/" +
      roundId +
      "/events"
  );
  const roundEventsQuery = query(roundEventsCollection, orderBy("startTime"));
  const { status: roundEventsStatus, data: roundEvents } =
    useFirestoreCollectionData(roundEventsQuery, {
      idField: "id",
    });

  const leagueRoundDataRef = doc(
    useFirestore(),
    "leagues/" +
      leagueInfo?.leagueRef +
      "/seasons/" +
      leagueInfo?.seasonRef +
      "/rounds",
    roundId
  );
  const { status: leagueRoundDataStatus, data: leagueRoundData } =
    useFirestoreDocData(leagueRoundDataRef, {
      idField: "id",
    });

  const predictionLeagueRoundDataRef = doc(
    useFirestore(),
    "userTournaments/" + leagueInfo?.id + "/rounds/",
    roundId
  );
  const {
    status: predictionLeagueRoundDataStatus,
    data: predictionLeagueRoundData,
  } = useFirestoreDocData(predictionLeagueRoundDataRef, {
    idField: "id",
  });

  const userRoundDataRef = doc(
    useFirestore(),
    "userTournaments/" + leagueInfo?.id + "/rounds/" + roundId + "/users/",
    user.uid
  );
  const { status: userRoundDataStatus, data: userRoundData } =
    useFirestoreDocData(userRoundDataRef, {
      idField: "id",
    });

  useEffect(() => {
    if (
      userRoundDataStatus === "success" &&
      leagueRoundDataStatus === "success" &&
      roundEventsStatus === "success" &&
      predictionLeagueRoundDataStatus === "success"
    ) {
      roundDispatch({
        type: "setData",
        value: {
          userRoundData: userRoundData,
          leagueRoundData: leagueRoundData,
          roundEvents: roundEvents,
          predictionLeagueRoundData: predictionLeagueRoundData,
        },
      });
    }
  }, [
    userRoundDataStatus,
    leagueRoundDataStatus,
    roundEventsStatus,
    predictionLeagueRoundDataStatus,
    userRoundData,
    leagueRoundData,
    roundEvents,
    predictionLeagueRoundData,
  ]);

  return null;
}

export { useRoundData };
